// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__4kDDr","inputWrap":"styles_inputWrap__6BWox","input":"styles_input__2RweC"};